export default {
    type: '',
    itemid: 0,
    declid: 0,
    declinable: 'N',
};
